<app-header-mobile (goBack)="goBack($event)" [headerTitle]="headerMessage" class="red-color"></app-header-mobile>

<div *ngIf="offersList.length" class="wrap-coupon-area">
    <div *ngFor="let offer of offersList" class="apply-coupon-code">
        <div class="header">
            <div class="coupon-code">{{offer.couponCode}}</div>
            <div class="expiry">Expiry : {{offer.endingDate | date:'dd/MM/yy'}}</div>
        </div>
        <div class="coupon-description">
            <div class="description-inner">
                <p>{{offer.title}}</p>
            </div>
            <div class="coupon-footer">
                <strong>T&C Apply</strong>
                <button *ngIf="!hideApply" (click)="applyCoupon(offer)" class="btn_primary">Apply</button>
            </div>
        </div>
    </div>

</div>


<div *ngIf="!offersList.length" class="wrap-coupon-area">
    <app-no-item-available *ngIf="error" [msg]="false" [itemMsg]="false"></app-no-item-available>
    <!-- <div class="offer">
        <app-shimmer [type]="'coupon'"></app-shimmer>
    </div>
    <div class="offer">
        <app-shimmer [type]="'coupon'"></app-shimmer>
    </div>
    <div class="offer">
        <app-shimmer [type]="'coupon'"></app-shimmer>
    </div>
    <div class="offer">
        <app-shimmer [type]="'coupon'"></app-shimmer>
    </div> -->
    <!-- <div class="offer">
        <app-shimmer [type]="'coupon'"></app-shimmer>
    </div> -->

</div>
